<template>
  <page>
    <template slot="content">
      <help-content :title="'歩数イベントにおける異常データの回避方法'">
        <template slot="content">
          <div class="text">
            イベントを作成する時に、<b>一日あたりの上限歩数</b>を設定できます。上限を超える歩数はイベントのスコアにカウントされません。合理的な上限値を設定することによって、異常（不正）データを回避することができます。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/HelpAdmin3.vue